import { DialogContentText, styled } from '@mui/material'

export const StyledDialogContentText = styled(DialogContentText)(({ theme }) => ({
  '& .MuiPaper-root': { padding: '32px' },
}))
